import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { EntityState } from '@api/models/enums/EntityState';
import { EstablishmentDto } from '@api/models/establishment/EstablishmentDto';
import { establishmentService } from '@api/services/services';

export interface EstablishmentListFilter extends ListFilter {
  state?: EntityState;
}

export type EstablishmentListState = ListType<EstablishmentDto, EstablishmentListFilter>;

const initialState: EstablishmentListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: EntityState.Active,
    sortBy: 'name',
    sortDesc: false,
  },
};

export const establishmentListSlice = listSlice({
  name: 'establishmentList',
  initialState,
});

export const selectEstablishmentList = (state: RootState) => state.establishmentList;
export const establishmentListActions = establishmentListSlice.actions;

export const getEstablishmentList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectEstablishmentList(storeState);

  const handleGetData = (size: number) => {
    return establishmentService.query({
      q: data.query.q,
      state: data.query.state,
      page: data.query.page,
      size: size,
      sort: getListSort(data)},
      { cancelToken: cancelToken as any }
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: establishmentListActions,
    getData: handleGetData,
  });
};
